import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0,
  class: "btns"
};
const _hoisted_3 = {
  key: 1
};
import { createIconNode } from '@/component-create/utils/common';

import { toRefs, ref, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '40%'
    },
    footers: {
      type: Array
    },
    customContent: [Function, Object],
    getInstance: Function,
    handler: Object
  },
  emits: ['save'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const prop = __props;
    const emit = __emit;
    const {
      title,
      footers,
      getInstance,
      customContent,
      width
    } = toRefs(prop);
    const visible = ref(false);
    const instance = new Proxy({}, {});
    const contentNode = ref();
    const customProp = ref();
    const customRef = ref();
    /**
     * 暴露属性方法
     */
    if (getInstance?.value) {
      getInstance.value(instance);
    }
    instance.open = open;
    instance.close = close;
    /**
     * 打开对话框
     * @param data
     */
    function open(data) {
      return new Promise(resolve => {
        visible.value = true;
        customProp.value = data;
        if (prop.customContent && typeof prop.customContent === 'function') {
          contentNode.value = prop.customContent(data);
        }
        nextTick(() => {
          resolve(true);
        });
      });
    }
    /**
     * 关闭对话框
     */
    function close() {
      visible.value = false;
      if (customRef.value && customRef.value.__close) {
        customRef.value.__close();
      }
    }
    /**
     * 取消
     */
    function cancle() {
      close();
    }
    function save() {
      emit('save');
    }
    __expose({
      open,
      close
    });
    /**
     * 创建按钮
     * @param el VNode绘制函数
     */
    function createButton(el) {
      return el(customRef);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: _unref(title),
        width: _unref(width),
        onClose: close
      }, {
        footer: _withCtx(() => [_unref(footers) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(footers).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footers), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["item", {
              'first': index === 0
            }])
          }, [item.el ? (_openBlock(), _createBlock(_resolveDynamicComponent(createButton(item.el)), {
            key: 0
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: item.type,
            icon: _unref(createIconNode)(item.icon),
            onClick: item.handler
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["type", "icon", "onClick"]))], 2);
        }), 128))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: cancle
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("确认")])),
          _: 1
        })]))]),
        default: _withCtx(() => [_createElementVNode("div", null, [_renderSlot(_ctx.$slots, "default"), _unref(contentNode) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(contentNode)), {
          key: 0
        })) : _createCommentVNode("", true), typeof _unref(customContent) === 'object' ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(customContent)), _mergeProps({
          key: 1,
          ref_key: "customRef",
          ref: customRef
        }, _unref(customProp) || {}), null, 16)) : _createCommentVNode("", true)])]),
        _: 3
      }, 8, ["modelValue", "title", "width"]);
    };
  }
});